import { render } from "./Micomprocedure.vue?vue&type=template&id=f9227ebc"
import script from "./Micomprocedure.vue?vue&type=script&lang=js"
export * from "./Micomprocedure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__